import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@mui/material";

import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";

export const RfidFilter: React.FC<ColumnFilterProps> = ({
  tableName,
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const value = useSelector((state: RootState) => filterSelectorValue(state, fieldName));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isEmptyChecked = value?.operator === FilterOperator.IsEmpty && !!value?.value;
  const isNotEmptyChecked = value?.operator === FilterOperator.IsNotEmpty && !!value?.value;

  return (
    <>
      <div>
        <Checkbox
          checked={isEmptyChecked}
          onChange={() => {
            dispatch(
              filterUpdateAction({
                id: fieldName,
                name: fieldName,
                operator: FilterOperator.IsEmpty,
                value: !isEmptyChecked,
              })
            );
          }}
        />
        {t(`${tableName}.filters.noRfid`)}
      </div>
      <div>
        <Checkbox
          checked={isNotEmptyChecked}
          onChange={() => {
            dispatch(
              filterUpdateAction({
                id: fieldName,
                name: fieldName,
                operator: FilterOperator.IsNotEmpty,
                value: !isNotEmptyChecked,
              })
            );
          }}
        />
        {t(`${tableName}.filters.hasRfid`)}
      </div>
    </>
  );
};
